<template>
  <SwitchGroup :class="size === 'sm' ? 'py-1' : 'py-3'">
    <div>
      <div class="flex items-center" :class="size === 'sm' ? 'gap-2' : 'gap-4'">
        <Switch
            v-model="enabled"
            :class="enabled ? 'bg-[#615E8D]' : 'bg-gray-600'"
            class="relative inline-flex items-center rounded-full transition-colors shrink-0"
            :style="switchStyle"
        >
          <div
            :class="[enabled ? 'bg-[#D2A1FF]' : 'bg-gray-400', thumbTranslate]"
            class="inline-flex items-center justify-center transform rounded-full transition-transform"
            :style="thumbStyle"
          >
            <svg v-if="enabled" :width="iconSize" :height="iconSize" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-[#181320]">
              <path fill="currentColor" d="M8.79205 12.1974L10.746 14.1514L16.6078 8.28955C16.6078 8.28955 17.2591 7.63806 17.9104 8.28955C18.5618 8.94103 17.9104 9.59218 17.9104 9.59218L11.3973 16.1053C11.3973 16.1053 10.7459 16.7565 10.0947 16.1053L7.48942 13.5001C7.48942 13.5001 6.83811 12.849 7.48942 12.1974C8.14074 11.5459 8.79205 12.1974 8.79205 12.1974Z"/>
            </svg>
            <svg v-else :width="iconSize" :height="iconSize" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-gray-300">
              <path d="M16.7 7.5L7.69995 16.5M7.69995 7.5L16.7 16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </div>
        </Switch>
        <SwitchLabel v-if="props.label" class="text-[#f0f1ff]" :class="size === 'sm' ? 'text-xs' : ''">{{ props.label }}</SwitchLabel>
      </div>
      <div v-if="props.description" class="text-gray-500 mt-2 text-sm">
        {{ props.description }}
      </div>
    </div>
  </SwitchGroup>
</template>

<script setup lang="ts">
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";

interface Props {
  modelValue: boolean;
  label?: string;
  description?: string;
  size?: 'default' | 'sm';
}

const props = withDefaults(defineProps<Props>(), {
  size: 'default',
});
const enabled = ref(false);
const emit = defineEmits(["update:modelValue"]);

const switchStyle = computed(() => props.size === 'sm'
  ? { width: '36px', height: '22px', padding: '3px' }
  : { width: '49px', height: '30px', padding: '3.75px' }
);

const thumbStyle = computed(() => props.size === 'sm'
  ? { width: '16px', height: '16px' }
  : { width: '22.5px', height: '22.5px' }
);

const thumbTranslate = computed(() => {
  if (props.size === 'sm') return enabled.value ? 'translate-x-[14px]' : 'translate-x-0';
  return enabled.value ? 'translate-x-[17px]' : 'translate-x-0';
});

const iconSize = computed(() => props.size === 'sm' ? 14 : 24);

watch(
    () => props.modelValue,
    () => {
      enabled.value = props.modelValue;
    },
    { immediate: true },
);

watch(enabled, () => {
  emit("update:modelValue", enabled.value);
});
</script>
